import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import config from '../config/config.json';
import { init } from '../graphql/client';
import { getCurrentUserWithBreweries } from '../graphql/users';
import { getUserBearerToken } from './auth';

export const firebaseApp = firebase.initializeApp(config.firebase);
export const firebaseAuth = firebaseApp.auth();
export const firebaseDb = firebaseApp.database();
export const firestoreDb = firebase.firestore();

export function initializeAuth() {
  return new Promise((resolve, reject) => {
    const unsub = firebase.auth().onAuthStateChanged(
      async user => {
        unsub();
        if (!user) {
          resolve(null);
          return;
        }

        const token = await getUserBearerToken();
        init(token);
        const currentUserAndBreweries = await getCurrentUserWithBreweries();
        return resolve(currentUserAndBreweries);
      },
      error => reject(error)
    );
  });
}



// WEBPACK FOOTER //
// ./src/firebase/index.js